import { dateFormatter, localeFormatter } from '../../../../utils/formatters';
// todo возможно эту хрень надо вынести и сделать глобальной как фильтры и юзать везде для генерации отображений
export const applicantFieldFormatters = {
  legal_entity_type: v => localeFormatter('user.type', v),
  applicant_role: v => localeFormatter('applicant.roles', v),
  last_name: v => v,
  first_name: v => v,
  middle_name: v => v,
  gender: v => localeFormatter('gender', v),
  citizenship: v => localeFormatter('citizenship.type', v),
  birth_date: v => dateFormatter(v),
  place_of_birth: v => v,
  snils: v => v,
  inn: v => v,
  registration_type: v => localeFormatter('registration.type', v),
  phone: v => v,
  email: v => v,
  identity_type: v => localeFormatter('identity.type', v),
  identity_series: v => v,
  identity_number: v => v,
  identity_issuer: v => v,
  identity_issue_date: v => dateFormatter(v),
  address_registration_entrepreneur: v => v,
  address: v => v,
  registration_address: v => v,
};
